import { QueryClientProvider } from "@tanstack/react-query";
import { applyTheme } from "@squeek/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { queryClient } from "./client";
import { ReviewApp } from "./app";
import { AdminWalletProvider, AdminWalletUi } from "../wallet";
import "../styles.css";

applyTheme("dark");
const root = document.getElementById("root");
if (!root) throw new Error("Missing #root application mount");
createRoot(root).render(<StrictMode><AdminWalletProvider><QueryClientProvider client={queryClient}><AdminWalletUi><ReviewApp /></AdminWalletUi></QueryClientProvider></AdminWalletProvider></StrictMode>);
